import { isTreeItemGuard } from './isTreeItemGuard';
export const getListItemId = ({ item, groupedId, getId }) => {
    let id = groupedId;
    if (typeof getId === 'function') {
        id = getId(isTreeItemGuard(item) ? item.data : item);
    }
    else if (item && typeof item === 'object' && 'id' in item && item.id) {
        id = item.id;
    }
    return id;
};
